import Prism from './Prism.vue'

export default Prism
